import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType, FormlyMaterialModule } from '@ngx-formly/material';
import { DatetimePickerProps } from 'app/core/json-schema-controls/models/datetime-picker-props.model';

@Component({
  selector: 'app-datetime-picker-type',
  standalone: true,
  imports: [
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatAutocompleteModule,
    MatInputModule,
    FormlyMaterialModule,
    ReactiveFormsModule,
    FormlyModule,
    CommonModule,
    MatFormFieldModule,
    MatIconModule,
  ],
  templateUrl: './datetime-picker-type.component.html',
  styleUrl: './datetime-picker-type.component.scss',
})
export class DatetimePickerTypeComponent extends FieldType<FormlyFieldConfig<DatetimePickerProps>> {
  today = new Date();

  get selectFormControl(): FormControl {
    return this.formControl as unknown as FormControl;
  }
}
